import { useStaticData } from '@mc/static-data-react'

import { PrimaryCategoryAndSubcategory } from 'libs/server/api'

export const CMPageBrowseText = ({ defaultText }: { defaultText: string }) => {
  const { primaryGrowthCatAndSubcat } = useStaticData<{
    primaryGrowthCatAndSubcat: PrimaryCategoryAndSubcategory
  }>()
  const title = primaryGrowthCatAndSubcat.primaryCategory?.name ?? defaultText

  return <span>{title}</span>
}
